import { Table } from 'antd';
import TableComponent from 'components/Table/TableComponent';
import dayjs from 'dayjs';
import useQueryParam from 'hooks/useQueryPrams';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import React, { memo } from 'react';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { formatCurrency } from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

interface Iprops {
  data: any;
  loading: boolean;
  onClickRow?: (record: any) => void;
  selectedRowKey?: string;
  isShowMapCustom?: boolean;
}
const TableEmployeeRouteTracking = memo((props: Iprops) => {
  const { data, loading, onClickRow, selectedRowKey, isShowMapCustom } = props;
  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const columns: ColumnsTypeCustom = [
    {
      title: 'STT',
      dataIndex: 'stt',
      width: 50,
      render: (_: any, __: any, index: number) =>
        (page - 1) * page_size + index + 1,
    },
    // {
    //   title: 'Ngày thực hiện',
    //   dataIndex: 'implementationDate',
    //   width: 100,
    //   render: (text: any) => dayjs(text).format('DD/MM/YYYY'),
    // },
    {
      title: 'Mã đội',
      dataIndex: ['tteamSales', 'subId'],
      width: 80,
    },
    {
      title: 'Đội bán',
      dataIndex: ['tteamSales', 'name'],
      width: 120,
    },
    {
      title: 'KH đã chăm sóc',
      dataIndex: 'customerWasCare',
      width: 130,
    },
    {
      title: 'KH còn lại',
      dataIndex: 'remainingCustomers',
      width: 90,
    },
    {
      title: 'Doanh thu dự kiến',
      dataIndex: 'expectedRevenue',
      width: 150,
      render: (value: any) =>
        value
          ? formatCurrency({
              value,
              round: true,
            })
          : '-',
    },
    {
      title: 'Tuyến',
      dataIndex: ['troute', 'id'],
      width: 100,
    },
    {
      title: 'Doanh thu thực hiện',
      dataIndex: 'realizedRevenue',
      width: 160,
      render: (value: any) =>
        value
          ? formatCurrency({
              value,
              round: true,
            })
          : '-',
    },
    {
      title: 'Trạng thái',
      dataIndex: ['tsaleStatus', 'name'],
      width: 130,
    },
    {
      title: 'Chuyến',
      dataIndex: '',
      width: 100,
    },
  ];
  return (
    <Content>
      <TableComponent
        rowKey={(record) => record.salePlanningId}
        dataSource={data?.items || []}
        columns={columns}
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{
          current: data?.pageInfo?.currentPage,
          pageSize: data?.pageInfo?.pageSize,
          total: data?.pageInfo?.totalItems,
          onChange: HocChangePagination(),
        }}
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              onClickRow && onClickRow(record);
            },
          };
        }}
        rowClassName={(record, index) => {
          return isShowMapCustom && selectedRowKey === record.salePlanningId
            ? 'row-selected'
            : index % 2 !== 0
              ? `even-row `
              : ``;
        }}
      />
    </Content>
  );
});

export default TableEmployeeRouteTracking;
